var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTiktok(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25F4EE",
    d: "M12.3 12.9v-1.2a5 5 0 0 0-.9-.1 5.4 5.4 0 0 0-3.1 9.8 5.4 5.4 0 0 1 4-8.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#25F4EE",
    d: "M12.5 22.3a2.5 2.5 0 0 0 2.5-2.4V4.6h2.2a4.1 4.1 0 0 1-.1-.8h-3v15.2a2.5 2.5 0 0 1-3.6 2.2 2.5 2.5 0 0 0 2 1.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C55",
    d: "M22.4 9.9V8.8a4 4 0 0 1-2.2-.7 4.1 4.1 0 0 0 2.2 1.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE2C55",
    d: "M20.2 8.1a4.1 4.1 0 0 1-1-2.7h-.8a4.1 4.1 0 0 0 1.8 2.7ZM11.4 15.2a2.5 2.5 0 0 0-1.2 4.7 2.5 2.5 0 0 1 2.1-3.8c.3 0 .6 0 .9.1v-3a5 5 0 0 0-.9-.1h-.2v2.3l-.7-.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M22.4 9.9v2.3a7.1 7.1 0 0 1-4.1-1.3v6a5.4 5.4 0 0 1-5.4 5.4 5.4 5.4 0 0 1-3.1-1 5.4 5.4 0 0 0 9.3-3.8v-6a7.1 7.1 0 0 0 4.2 1.3v-3a4.2 4.2 0 0 1-.9.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M18.3 16.9v-6a7.1 7.1 0 0 0 4.1 1.3V9.9a4.1 4.1 0 0 1-2.2-1.8 4.1 4.1 0 0 1-1.8-2.7H16v15.3a2.5 2.5 0 0 1-4.5 1.4 2.5 2.5 0 0 1 1.1-4.8c.3 0 .6 0 .9.1v-2.3a5.4 5.4 0 0 0-4 8.6 5.4 5.4 0 0 0 3.1 1 5.4 5.4 0 0 0 5.4-5.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTiktok);
export default __webpack_public_path__ + "static/media/logo-tiktok.533065f4b2402ef16f8ec1060c84bd70.svg";
export { ForwardRef as ReactComponent };